import React from 'react';
import { connect } from 'react-redux'
import ImageUploader from 'react-images-upload';
import { RIEInput } from '@attently/riek';
import moment from 'moment';
import UserRequests from './../../requests/UserRequests';
import { s3Conf } from './../../config/s3';
import Modal from './../layout/Modal';
import { loadUser, updateUser, updateUserImage, loadUserAverages } from './../../actions/user';
import { isReadOnly } from './../../lib/utils/demo';

const mapStateToProps = state => {
    return { user: state.user.data, session: state.session, aggregations: state.user.averages }
}
const mapDispachToProps = dispatch => {
    return {
        updateImage: (session, params) => dispatch(updateUserImage(session, params)),
        updateUser: (session, params) => dispatch(updateUser(session, params)),
        loadUser: (session, params) => dispatch(loadUser(session, params)),
        loadUserAverages: (session, params) => dispatch(loadUserAverages(session, params))
    }
}

class ProfileCard extends React.Component {

    constructor() {
        super();
        this.state = {
            board_id: null,
            manufacturer_id: null,
            uploaderInstance: 1,
            uploadError: null,
            showImage: false
        };
        this.showImage = this.showImage.bind(this);
        this.hideImage = this.hideImage.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.saveField = this.saveField.bind(this);
    }

    componentDidMount() {
        if (this.props.session.isLoggedIn) {
            this.props.loadUser(this.props.session, { id: this.props.session.user.id });
            this.props.loadUserAverages(this.props.session, { id: this.props.session.user.id });
        }
    }

    showImage() { this.setState({ showImage: true }); }
    hideImage() { this.setState({ showImage: false }); }

    // riek hands back {[propName]: value}, which is already the PUT body.
    saveField(data) {
        this.props.updateUser(this.props.session, {
            id: this.props.session.user.id,
            data: data,
        });
    }

    /*
    react-images-upload fires onChange with an empty array when it rejects
    everything you picked, because singleImage rebuilds files as a fresh [] and
    its componentDidUpdate only compares references. Posting that sent a body
    carrying user_id and no photo, and /api/user/images answered 400 "No photo
    was uploaded" with nothing on screen to say the file was refused.
    */
    onDrop(pictureFiles, pictureDataURLs) {
        if (!pictureFiles.length) {
            this.setState({ uploadError: 'That file was not accepted. Use a jpg, jpeg, png or gif under 5MB.' });
            return;
        }
        const formData = UserRequests.createFormRequest({ user_id: this.props.session.user.id });
        pictureFiles.forEach((file, i) => {
            formData.append('photo', file)
        })
        this.props.updateImage(this.props.session, { data: formData });
        this.setState({ uploadError: null, uploaderInstance: this.state.uploaderInstance + 1 })
    }

    render() {
        const { user, aggregations } = this.props;
        const image = user.profile_img
            ? s3Conf.root + user.profile_img
            : '/img/session_default_lg.png';

        /*
         * A count that has not arrived is not zero. The averages payload is a
         * separate request from the lists beside it, so it can still be in
         * flight - or have failed - while the rest of the card renders.
         */
        const stat = (n) => (typeof n === 'number' ? n : '--');
        const rating = Number(aggregations.session_rating) || 0;

        return (
            <React.Fragment>
                <div className="gw-profile-head">
                    <img
                        className="gw-profile-img"
                        src={image}
                        alt=""
                        onClick={this.showImage}
                    />
                    <div>
                        <div className="gw-profile-name gw-inline-edit">
                            <RIEInput
                                required={false}
                                value={user.first_name || "First name"}
                                defaultValue={user.first_name}
                                change={this.saveField}
                                propName="first_name"
                                className="gw-rie"
                            />
                            {" "}
                            <RIEInput
                                required={false}
                                value={user.last_name || "Last name"}
                                defaultValue={user.last_name}
                                change={this.saveField}
                                propName="last_name"
                                className="gw-rie"
                            />
                        </div>
                        {user.createdAt &&
                            <div className="gw-profile-since">
                                SINCE {moment(user.createdAt).format("MM / YYYY")}
                            </div>
                        }
                    </div>
                </div>

                <hr className="gw-rule" />

                <div className="d-flex flex-column" style={{ gap: '14px' }}>
                    <div className="gw-eyebrow">Lifetime</div>
                    <div className="gw-stat-row">
                        <div className="gw-stat-label">Sessions logged</div>
                        <div className="gw-stat-value">{stat(aggregations.total_sessions)}</div>
                    </div>
                    <div className="gw-stat-row">
                        <div className="gw-stat-label">Boards in quiver</div>
                        <div className="gw-stat-value">{stat(this.props.boardCount)}</div>
                    </div>
                    <div className="gw-stat-row">
                        <div className="gw-stat-label">Spots surfed</div>
                        <div className="gw-stat-value">{stat(this.props.spotCount)}</div>
                    </div>
                </div>

                <hr className="gw-rule" />

                <div className="d-flex flex-column" style={{ gap: '10px' }}>
                    <div className="gw-stat-row">
                        <div className="gw-eyebrow">Avg rating</div>
                        <div className="gw-mono" style={{ fontSize: '13px', color: '#3fd0dd' }}>
                            {rating ? `${rating} / 10` : '--'}
                        </div>
                    </div>
                    <div className="gw-meter">
                        <div className="gw-meter-fill" style={{ width: `${rating * 10}%` }} />
                    </div>
                </div>

                <hr className="gw-rule" />

                <div className="d-flex flex-column" style={{ gap: '9px' }}>
                    <div className="gw-eyebrow">Actions</div>
                    {isReadOnly(this.props.session) ? (
                        <div className="gw-demo-note">
                            This is a shared demo account, so it is read-only.
                            Everything you see here is somebody's real logged
                            season. Sign up to log your own.
                        </div>
                    ) : (
                    <React.Fragment>
                    <button type="button" className="gw-btn gw-btn-primary" onClick={this.props.onLogSession}>Log a session</button>
                    <button type="button" className="gw-btn" onClick={this.props.onAddBoard}>Add a board</button>
                    <div className="gw-uploader">
                        <ImageUploader
                            key={this.state.uploaderInstance}
                            withIcon={false}
                            buttonText='Update profile photo'
                            onChange={this.onDrop}
                            imgExtension={['.jpg', '.jpeg', '.png', '.gif']}
                            maxFileSize={5242880}
                            label=''
                            withPreview={false}
                            singleImage={true}
                        />
                        {this.state.uploadError && (
                            <div className="gw-uploader-error">{this.state.uploadError}</div>
                        )}
                    </div>
                    </React.Fragment>
                    )}
                </div>
                <Modal
                    show={this.state.showImage}
                    handleClose={this.hideImage}
                    className="gw-lightbox"
                >
                    <div className="gw-lightbox-body">
                        <button
                            type="button"
                            className="gw-lightbox-close"
                            onClick={this.hideImage}
                            aria-label="Close"
                        >
                            &times;
                        </button>
                        <img src={image} alt="" />
                    </div>
                </Modal>
            </React.Fragment>
        )
    }
}

export default connect(mapStateToProps, mapDispachToProps)(ProfileCard);
